import script from "./OpsFeedbackManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsFeedbackManagement.vue?vue&type=script&setup=true&lang=js"

import "./OpsFeedbackManagement.vue?vue&type=style&index=0&id=523a2b2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523a2b2e"]])

export default __exports__